import React, { Component } from 'react';

import './styles.css';

export default function PhotoSection( { photo }) {
    return (<div className={'photo-div ' + photo}></div>);
}